<template>
  <component
    :is="component"
    :to="path"
    class="item"
    :class="{
      link: isLink,
      ended: assessment.ended,
      running: !assessment.ended,
    }"
  >
    <div class="item-wrapper">
      <AssessmentListItemHeader
        :title="assessment.title"
        :img-src="assessment.imgSrc"
        :infos="assessment.timeLeft > 0 ? `J-${assessment.daysLeft}` : ''"
        :color="colorIcon"
      />

      <div class="content">
        <ul v-if="showChapters" class="chapters">
          <li v-for="(chapter, index) in assessment.chapters" :key="chapter.id">
            <AssessmentListItemContentChapter
              :index="index"
              :title="chapter.title"
            />
          </li>
        </ul>
        <div class="footer">
          <ProgressBarLabel
            v-if="!assessment.ended"
            theme="secondary"
            :show-label="false"
            :show-quit="false"
            :count="assessment.count"
            :total="assessment.total"
          />

          <div class="dates">
            <AssessmentListItemContentDate
              :content="assessment.formatedDate"
              icon-name="hugeicons:calendar-03"
            />
            <AssessmentListItemContentDate
              :content="assessment.clockTime"
              icon-name="ic:baseline-access-time"
            />
          </div>
          <ButtonBase
            v-if="!assessment.ended"
            :class="{ visible: showAccessButton }"
            theme="quaternary"
            stroke="n"
            class="button"
            :disabled="false"
            rounded
            size="small"
            :to="path"
          >
            Réviser
          </ButtonBase>
        </div>
      </div>
    </div>
  </component>
</template>
<script setup lang="ts">
interface Props {
  assessment: AssessmentListItem;
  showAccessButton?: boolean;
  showChapters?: boolean;
  isLink?: boolean;
}

const props = defineProps({
  assessment: null,
  showAccessButton: { type: Boolean, default: true },
  showChapters: { type: Boolean, default: true },
  isLink: { type: Boolean, default: true }
});

const path = computed(
  () => `/${Sections.ChildForYou}/${props.assessment.uuid}`
);

const component = computed(() => {
  if (props.isLink) {
    return resolveComponent('NuxtLink');
  }
  return 'div';
});

const { $colors } = useNuxtApp();

const colorIcon = computed(() => {
  if (props.assessment.ended) {
    return $colors.neutral_600;
  } else {
    return $colors.quinary_dark;
  }
});
</script>

<style lang="scss" scoped>
.item {
  --color_highlight: var(--color_quinary_darker);
  --color_solid: var(--color_quinary);
  --color_select: var(--color_quinary_lighter);
  --color_text: var(--color_neutral_800);
  --color_text_light: var(--color_neutral_700);
  &.ended {
    --color_highlight: var(--color_neutral_600);
    --color_select: var(--color_neutral_50);
    --color_text: var(--color_neutral_800);
    --color_text_light: var(--color_neutral_500);
    &.ended {
      &::before {
        border-color: var(--color_secondary_lighter);
      }
    }
  }

  display: block;
  position: relative;
  text-align: left;
  .item-wrapper {
    display: flex;
    position: relative;
    flex-direction: column;
    padding: 0 0 var(--gap_m) 0;
    overflow: hidden;
    border-radius: var(--stroke_radius_n);
    gap: var(--gap_m);
  }
  &::before {
    content: '';
    display: block;
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: border 500ms $ease-in-quad, box-shadow 500ms $ease-in-quad;
    border-color: var(--color_secondary_light);

    @include stroke('n', 'l');
  }
  &.link {
    &:focus,
    &:hover {
      &::before {
        transition: border 500ms $ease-in-quad, box-shadow 500ms $ease-out-quad;
        border: var(--stroke_thickness_n) solid var(--color_secondary_light);
        background-color: var(--color_select);
      }
    }
  }
}
.content {
  display: flex;
  flex-direction: column;
  gap: var(--gap_m);
  padding: 0 var(--gap_m) 0 var(--gap_m);
}
.dates {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--gap_xxs);
}
.footer {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: end;
  column-gap: var(--gap_s);
  row-gap: var(--gap_m);
}
.progress {
  width: 86%;
}
.button {
  visibility: hidden;
  grid-column: 2 / 3;
  grid-row: 1 / 3;
  &.visible {
    visibility: visible;
  }
}
</style>
